import React from 'react';
import { TilesContainer } from './Tiles.styles';
import { getAppContentConfiguration } from '../../hooks/tileHook';

const Tiles: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { detailsPageUrlPattern } = getAppContentConfiguration();
  const detailsURL = detailsPageUrlPattern ?? '';
  return (
    <TilesContainer
      data-testid="TilesContainer"
      className="sc-result-items"
      data-details-url={detailsURL}
    >
      <>{children}</>
    </TilesContainer>
  );
};

export default Tiles;
